import Switch from '@mui/material/Switch';
import { styled } from '@mui/system';

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: '94px',
    height: '28px',
    padding: '0px',
    justifyContent: 'center',
    '& .MuiSwitch-switchBase': {
        color: '#B5BFBC',
        padding: '0px',
        justifyContent: 'center',
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#005C8E',
        },
    },
    '& .MuiSwitch-thumb': {
        color: '#E0E0E0',
        width: '36px',
        height: '23px',
        margin: '4px 3px 4px 5px',
        padding: '0px',
    },
    '& .MuiSwitch-track': {
        borderRadius: '20px',
        backgroundColor: '#005C8E',
        justifyContent: 'center',
        opacity: '1 !important',
        position: 'relative',
        '&:after': {
            color: '#E0E0E0',
            fontSize: '11px',
            position: 'absolute',
            right: '10px',
            top: '6px',
            content: '" Name"',
            transition: 'content 0.2s',
        },
        '&:before': {
            color: '#E0E0E0',
            fontSize: '11px',
            position: 'absolute',
            left: '10px',
            top: '6px',
            content: '"Alias"',
            transition: 'content 0.2s',
        },
    },
    '& .Mui-checked': {
        color: '#005C8E',
        transform: 'translateX(50px) !important',
    },
}));

export default MaterialUISwitch;
